import { RepositoriesRepositoryIdPatchRequest } from '@nativewaves/nw-cloud-sdk/content'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ContentAPI } from 'services/api'
import { repositoryQueryKeys } from 'services/queryKeys'

export const useRepositoryUpdateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: RepositoriesRepositoryIdPatchRequest) =>
      ContentAPI.repositories.repositoriesRepositoryIdPatch(params),
    onSuccess: (data) => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: repositoryQueryKeys.lists(),
        }),
        queryClient.invalidateQueries({
          queryKey: repositoryQueryKeys.detail({ repositoryId: data.id }).queryKey,
        }),
      ])
    },
  })
}
